function importAll(r) {
  const images = {};
  r.keys().forEach(item => {
    images[
      item
        .replace("./", "")
        .replace(".jpg", "")
        .replace(".png", "")
        .replace(".gif", "")
    ] = r(item);
  });
  return images;
}

const imported = importAll(
  require.context(`./`, false, /\.(png|jpg|svg|gif)$/)
);

const index = {};

Object.keys(imported).forEach(key => {
  index[key] = new Image();
  index[key].src = imported[key];
});

export default index;
